/* ==========================================================================
   Keiki Co. — All Products collection page
   Design reference: All Products Page.dc.html · Spec: SPEC.md

   Vanilla, no dependencies. Uses the Section Rendering API so facet, sort and
   load-more changes never reload the page.
   ========================================================================== */

(function () {
  'use strict';

  var MOBILE_MAX  = 760;
  var SIDEBAR_MIN = 1080;

  var root = document.querySelector('[data-keiki-collection]');
  if (!root) return;

  var sectionId = root.closest('[id^="shopify-section-"]');
  sectionId = sectionId ? sectionId.id.replace('shopify-section-', '') : null;

  var isMobile  = function () { return window.innerWidth < MOBILE_MAX; };
  var isSidebar = function () { return window.innerWidth >= SIDEBAR_MIN; };

  /* ------------------------------------------------------------------ rail */
  /* The whole point of this block: arrows and fades appear ONLY when there is
     something to scroll to, on each side independently, and re-evaluate on
     scroll and on resize. A rail that fits shows neither. */

  function initRail() {
    var rail = root.querySelector('[data-keiki-rail]');
    if (!rail) return;

    var prev   = root.querySelector('[data-keiki-rail-prev]');
    var next   = root.querySelector('[data-keiki-rail-next]');
    var fadeL  = root.querySelector('[data-keiki-fade-l]');
    var fadeR  = root.querySelector('[data-keiki-fade-r]');

    function sync() {
      var max      = rail.scrollWidth - rail.clientWidth;
      var showRight = max > 2 && (max - rail.scrollLeft) > 2;
      var showLeft  = rail.scrollLeft > 2;

      // Arrows are pointer affordances only — never on touch layouts.
      if (prev) prev.hidden = !showLeft  || isMobile();
      if (next) next.hidden = !showRight || isMobile();

      if (fadeL) fadeL.classList.toggle('is-on', showLeft);
      if (fadeR) fadeR.classList.toggle('is-on', showRight);
    }

    function step(dir) {
      rail.scrollBy({ left: dir * Math.round(rail.clientWidth * 0.72), behavior: 'smooth' });
    }

    rail.addEventListener('scroll', sync, { passive: true });
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    // Images load late — re-measure when the rail's content box changes.
    if (window.ResizeObserver) new ResizeObserver(sync).observe(rail);
    window.addEventListener('resize', sync);
    window.addEventListener('load', sync);

    // Bring the active tile into view on load without animating the page.
    var active = rail.querySelector('.keiki-tile.is-active');
    if (active) {
      var pad = 40;
      var left = active.offsetLeft - pad;
      if (left > 0) rail.scrollLeft = left;
    }

    sync();
  }

  /* -------------------------------------------------------------- filtering */

  var form    = root.querySelector('[data-keiki-facet-form]');
  var facets  = root.querySelector('[data-keiki-facets]');
  var main    = root.querySelector('[data-keiki-main]');
  var scrim   = document.querySelector('[data-keiki-scrim]');
  var fBtn    = root.querySelector('[data-keiki-filter-toggle]');
  var fLabel  = root.querySelector('[data-keiki-filter-label]');
  var fCount  = root.querySelector('[data-keiki-filter-count]');

  function activeFacetCount() {
    if (!form) return 0;
    return form.querySelectorAll('.keiki-opt__input:checked').length;
  }

  function syncFilterButton() {
    if (!fBtn) return;
    var open = isSidebar() && main.classList.contains('has-sidebar');
    fBtn.classList.toggle('is-open', open);
    fBtn.setAttribute('aria-expanded', String(open));
    if (fLabel) fLabel.textContent = open ? 'Hide filters' : 'Filters';
    var n = activeFacetCount();
    if (fCount) fCount.textContent = n ? '(' + n + ')' : '';
  }

  function openDrawer() {
    facets.classList.add('is-drawer');
    requestAnimationFrame(function () { facets.classList.add('is-open'); });
    scrim.hidden = false;
    requestAnimationFrame(function () { scrim.classList.add('is-on'); });
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    facets.classList.remove('is-open');
    scrim.classList.remove('is-on');
    document.body.style.overflow = '';
    setTimeout(function () {
      facets.classList.remove('is-drawer');
      scrim.hidden = true;
    }, 260);
  }

  if (fBtn) fBtn.addEventListener('click', function () {
    if (!isSidebar()) return openDrawer();
    main.classList.toggle('has-sidebar');
    syncFilterButton();
    try { localStorage.setItem('keiki:sidebar', main.classList.contains('has-sidebar') ? '1' : '0'); } catch (e) {}
  });

  if (scrim) scrim.addEventListener('click', closeDrawer);
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-keiki-drawer-close]')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && facets.classList.contains('is-open')) closeDrawer();
  });

  // Facet accordions
  root.addEventListener('click', function (e) {
    var head = e.target.closest('[data-keiki-facet-toggle]');
    if (!head) return;
    var facet = head.closest('[data-keiki-facet]');
    var open = facet.classList.toggle('is-open');
    head.setAttribute('aria-expanded', String(open));
    var sign = head.querySelector('.keiki-facet__sign');
    if (sign) sign.textContent = open ? '\u2013' : '+';
  });

  /* --- submit ------------------------------------------------------------ */
  /* Any facet or sort change rebuilds the URL and re-renders the section.
     Everything meaningful lives in the URL, so back/forward and sharing work. */

  var pending = null;

  function buildUrl() {
    var params = new URLSearchParams(new FormData(form));
    // Drop empties so the URL stays readable.
    var clean = new URLSearchParams();
    params.forEach(function (v, k) { if (v !== '' && v != null) clean.append(k, v); });
    return window.location.pathname + '?' + clean.toString();
  }

  function render(url, push) {
    if (pending) pending.abort();
    pending = new AbortController();
    root.setAttribute('aria-busy', 'true');

    var fetchUrl = url + (sectionId ? '&section_id=' + sectionId : '');
    fetch(fetchUrl, { signal: pending.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-keiki-collection]');
        if (!fresh) return;
        root.innerHTML = fresh.innerHTML;
        if (push) history.pushState({ keiki: true }, '', url);
        rebind();
        root.removeAttribute('aria-busy');
      })
      .catch(function (err) { if (err.name !== 'AbortError') window.location.href = url; });
  }

  function onFormChange(e) {
    // Price bands write into the hidden gte/lte inputs before we serialise.
    if (e.target.matches('[data-keiki-price-band]')) syncPriceBands();
    render(buildUrl(), true);
  }

  function syncPriceBands() {
    var bands = Array.prototype.slice.call(form.querySelectorAll('[data-keiki-price-band]:checked'));
    var min = form.querySelector('[data-keiki-price-min]');
    var max = form.querySelector('[data-keiki-price-max]');
    if (!min || !max) return;
    if (!bands.length) { min.value = ''; max.value = ''; return; }
    // Union of the selected bands — Shopify's price filter is a single range.
    var los = bands.map(function (b) { return Number(b.dataset.lo); });
    var his = bands.map(function (b) { return Number(b.dataset.hi); });
    min.value = Math.min.apply(null, los);
    max.value = Math.max.apply(null, his);
  }

  /* --- load more --------------------------------------------------------- */
  /* Appends the next page into the existing grid instead of replacing it. */

  function onLoadMore(e) {
    var btn = e.target.closest('[data-keiki-load-more]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.dataset.nextUrl;
    btn.textContent = 'Loading…';

    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + (sectionId ? 'section_id=' + sectionId : ''))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = root.querySelector('[data-keiki-grid]');
        var newCards = doc.querySelectorAll('[data-keiki-grid] .keiki-card');
        Array.prototype.forEach.call(newCards, function (c) { grid.appendChild(c); });

        var oldMore = root.querySelector('[data-keiki-more]');
        var newMore = doc.querySelector('[data-keiki-more]');
        if (newMore) { oldMore.replaceWith(newMore); } else { oldMore.remove(); }

        history.replaceState({ keiki: true }, '', url);
        rebind();
      });
  }

  /* --- add to cart ------------------------------------------------------- */

  var toast = document.querySelector('[data-keiki-toast]');
  var toastT;
  function flash(msg) {
    if (!toast) return;
    clearTimeout(toastT);
    toast.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#d9ac7c" stroke-width="2"><path d="M4 12l5 5L20 6"/></svg>' + msg;
    toast.hidden = false;
    toastT = setTimeout(function () { toast.hidden = true; }, 2200);
  }

  function onAdd(e) {
    var btn = e.target.closest('[data-keiki-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();          // must never open the PDP

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.classList.add('is-added');
        flash('Added ' + btn.dataset.title + ' to your bag');
        document.dispatchEvent(new CustomEvent('keiki:cart:updated'));
      })
      .catch(function () { flash('Could not add that — please try again'); });
  }

  /* --- density ----------------------------------------------------------- */

  function onView(e) {
    var btn = e.target.closest('[data-keiki-view]');
    if (!btn) return;
    var grid = root.querySelector('[data-keiki-grid]');
    if (!grid) return;
    grid.dataset.view = btn.dataset.keikiView;
    root.querySelectorAll('[data-keiki-view]').forEach(function (b) {
      b.classList.toggle('is-active', b === btn);
    });
    try { localStorage.setItem('keiki:view', btn.dataset.keikiView); } catch (e) {}
  }

  /* ------------------------------------------------------------- rebinding */

  function rebind() {
    form   = root.querySelector('[data-keiki-facet-form]');
    facets = root.querySelector('[data-keiki-facets]');
    main   = root.querySelector('[data-keiki-main]');
    fBtn   = root.querySelector('[data-keiki-filter-toggle]');
    fLabel = root.querySelector('[data-keiki-filter-label]');
    fCount = root.querySelector('[data-keiki-filter-count]');

    if (form) {
      form.addEventListener('change', onFormChange);
      form.addEventListener('submit', function (e) { e.preventDefault(); render(buildUrl(), true); });
    }

    // Restore preferences.
    try {
      if (localStorage.getItem('keiki:sidebar') !== '0' && isSidebar()) main.classList.add('has-sidebar');
      var v = localStorage.getItem('keiki:view');
      var grid = root.querySelector('[data-keiki-grid]');
      if (v && grid) {
        grid.dataset.view = v;
        root.querySelectorAll('[data-keiki-view]').forEach(function (b) {
          b.classList.toggle('is-active', b.dataset.keikiView === v);
        });
      }
    } catch (e) {}

    initRail();
    syncFilterButton();
  }

  root.addEventListener('click', onLoadMore);
  root.addEventListener('click', onAdd);
  root.addEventListener('click', onView);
  window.addEventListener('popstate', function () { render(window.location.href, false); });
  window.addEventListener('resize', syncFilterButton);

  if (isSidebar()) main.classList.add('has-sidebar');
  rebind();
})();
